// 全サービス共通の詳細ページテンプレート（データ駆動）
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import services, { CONTACT } from '../data/services';
import NotFound from './NotFound';

function ServiceDetail() {
  const { slug } = useParams();
  const service = services.find((item) => item.slug === slug);

  if (!service) {
    return <NotFound />;
  }

  const { detail } = service;
  const related = services.filter((item) => item.slug !== slug).slice(0, 3);

  return (
    <main className="service-detail">
      {/* 画像バナー */}
      <div className="service-hero" style={{ backgroundImage: `url(${service.image})` }}>
        <div className="service-hero-overlay">
          <nav className="breadcrumb" aria-label="breadcrumb">
            <Link to="/">หน้าหลัก</Link>
            <span className="material-icons" aria-hidden="true">chevron_right</span>
            <span>{service.name}</span>
          </nav>
          <h1>{detail.title}</h1>
        </div>
      </div>

      <div className="service-detail-container">
        <p className="service-intro">{detail.intro}</p>

        <h2>{detail.featuresTitle}</h2>
        <ul className="service-features">
          {detail.features.map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>

        {detail.sections.map((section) => (
          <React.Fragment key={section.heading}>
            <h2>{section.heading}</h2>
            <p>{section.body}</p>
          </React.Fragment>
        ))}

        {/* 連絡先カード */}
        <div className="service-contact-card">
          <h2>นัดหมาย / สอบถาม</h2>
          <p>ทีมงานของเรายินดีให้คำปรึกษาและจองคิวให้คุณ</p>
          <div className="service-contact-actions">
            <a
              href={CONTACT.lineUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="access-line"
            >
              <span className="material-icons" aria-hidden="true">chat</span>
              จองคิวผ่าน LINE
            </a>
            <a href={CONTACT.phoneHref} className="access-map-link">
              <span className="material-icons" aria-hidden="true">call</span>
              โทร {CONTACT.phone}
            </a>
          </div>
        </div>
      </div>

      {/* 関連サービス */}
      <div className="related-services">
        <h2>บริการอื่นๆ ของเรา</h2>
        <div className="related-grid">
          {related.map((item) => (
            <Link to={`/services/${item.slug}`} key={item.slug} className="related-card">
              <img src={item.image} alt={item.cardTitle} loading="lazy" />
              <div>
                <h3>{item.cardTitle}</h3>
                <span className="service-card-link">
                  ดูรายละเอียด
                  <span className="material-icons" aria-hidden="true">arrow_forward</span>
                </span>
              </div>
            </Link>
          ))}
        </div>
        <div className="more-button-container">
          <Link to="/#services" className="more-button">กลับไปยังบริการทั้งหมด</Link>
        </div>
      </div>
    </main>
  );
}

export default ServiceDetail;
